import { api } from '../lib/api-client.js';

export interface VendorWorkOrderListItem {
  id: string;
  displayNumber: string;
  title: string;
  severity: string;
  status: string;
  dueAt: string | null;
  building: { id: string; name: string };
  unit: { id: string; label: string } | null;
  hasUnitVisitLog: boolean;
}

export async function fetchVendorWorkOrders() {
  return api<{
    today: VendorWorkOrderListItem[];
    thisWeek: VendorWorkOrderListItem[];
    later: VendorWorkOrderListItem[];
    completed: VendorWorkOrderListItem[];
  }>('/vendor/work-orders');
}

export async function fetchVendorWorkOrder(id: string) {
  return api<{ workOrder: Record<string, unknown> }>(`/vendor/work-orders/${id}`);
}

export async function submitVendorSignoff(
  workOrderId: string,
  body: { completionNotes: string | null; photoUploadIds: string[]; signatureUploadId: string },
) {
  return api(`/vendor/work-orders/${workOrderId}/signoff`, { method: 'POST', body });
}

export async function fetchVendorUnitLogs(workOrderId: string) {
  return api<{
    building: { id: string; name: string } | null;
    progress: { signedOff: number; total: number };
    items: Array<{
      id: string;
      unitId: string;
      unitNumber: string;
      status: 'pending' | 'signed_off' | 'no_access';
      outcome: string | null;
      pestTypes: string[];
      treatmentNotes: string | null;
      signedAt: string | null;
    }>;
  }>(`/vendor/work-orders/${workOrderId}/unit-logs`);
}

export async function fetchVendorLogIndex() {
  return api<{
    items: Array<{
      workOrderId: string;
      displayNumber: string;
      title: string;
      building: { id: string; name: string };
      progress: { signedOff: number; total: number };
    }>;
  }>('/vendor/work-orders/logs/index');
}

export async function submitUnitLogSignoff(
  workOrderId: string,
  unitLogId: string,
  body: Record<string, unknown>,
) {
  return api(`/vendor/work-orders/${workOrderId}/unit-logs/${unitLogId}/signoff`, {
    method: 'POST',
    body,
  });
}

export async function vendorPresignUpload(body: {
  kind: 'work_order_photo' | 'work_order_signature';
  contentType: string;
  filename: string;
  sizeBytes: number;
}) {
  return api<{
    uploadId: string;
    uploadUrl: string;
    headers: Record<string, string>;
  }>('/vendor/uploads/presign', { method: 'POST', body });
}
